module.exports = __webpack_public_path__ + "frontend/static/media/placeholderC.f5d27386.gif";